 
export class KontaktSpoergsmaal {
        public id: string;
        public navn: string;
        public brugernavn: string;
        public email: string;
        public telefonNummer: string;
        public skoleNavn: string;
        public skoleKommune: number;
        public funktion: string;
        public emne: string;
        public tekst: string;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/KontaktSpoergsmaal.ts